export default function () {

    const $responseForm = $('.js-response-form');
    const $responseItems = $responseForm.find('input');
    const $answerList = $('.js-answer-list');
    const $answerItems = $answerList.find('td > div');

    $.each($answerItems, function (index, item) {
        $(item).on('click', function () {
            resetActive();
            $(this).addClass('active');
            $($responseItems[index]).prop('checked', true);
            $($responseItems[index]).parent().parent().addClass('active');
        });
        $(item).on('mouseenter', function () {
            resetHover();
            $($responseItems[index]).parent().parent().addClass('hover');
        });
        $(item).on('mouseleave', function (e) {
            e.stopPropagation();
            resetHover();
        });
    });

    $.each($responseItems, function (index, item) {
        $(item).on('click', function () {
            resetActive();
            $(this).parent().parent().addClass('active');
            $($answerItems[index]).addClass('active');
        });
        $(item).parent().parent().on('mouseenter', function () {
            resetHover();
            $($answerItems[index]).addClass('hover');
        });
        $(item).parent().parent().on('mouseleave', function () {
            resetHover();
        });
    });

    function resetHover() {
        for (let i = 0; i < $answerItems.length; i++) {
            $($responseItems[i]).parent().parent().removeClass('hover');
            $($answerItems[i]).removeClass('hover');
        }
    }

    function resetActive() {
        for (let i = 0; i < $answerItems.length; i++) {
            $($responseItems[i]).parent().parent().removeClass('active');
            $($answerItems[i]).removeClass('active');
        }
    }
}